import React, { useState, useEffect } from 'react';
import Header from '../Pages/LandingPage/Header';
import Rank from './RankCss';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalBody
} from 'mdb-react-ui-kit';
import Card from '../Pages/RankCard/Card';

function RankCard() {
  const [optSmModal, setOptSmModal] = useState(false);
  const [applicationNo, setApplicationNo] = useState('');
  const [dob, setDob] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);

  const [captcha, setCaptcha] = useState('');
  const [captchaInput, setCaptchaInput] = useState('');

  useEffect(() => {
    generateCaptcha();
  }, []);

  const toggleShow1 = (e) => {
    e.preventDefault();
    setOptSmModal(!optSmModal);
  };

  const generateCaptcha = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(result);
    setCaptchaInput('');
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!applicationNo || !dob || !captchaInput) {
      alert('All fields are mandatory');
    } else if (captcha.toLowerCase() !== captchaInput.toLowerCase()) {
      alert('Captcha does not match');
      generateCaptcha(); // Refresh on fail
    } else {
      await rankCardData();
    }
  };

  const [data, setData] = useState(null);

  async function rankCardData() {
    try {
      const response = await fetch('https://admin.aicee.in/counselling/rank-card', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          credentials: applicationNo,
          password: dob
        })
      });

      const result = await response.json();

      if (result.success) {
        if (result.data.length === 0) {
          alert('Result Not Found');
        } else {
          const matched = result.data.find(
            (item) => item.application_no === applicationNo
          );
          setData(matched || result.data[0]);
          setOptSmModal(true);
        }
      } else {
        alert(result.message);
      }
    } catch (error) {
      alert('Something went wrong while fetching data.');
      console.error(error);
    }
  }

  return (
    <Rank>
      <Header />
      <div className="mt-4 bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg shadow-lg flex flex-col items-center">
        <div className="px-4 py-4 sm:px-10 w-full">
          <h2 className="text-lg font-semibold text-center text-[#e35d26]">
            AICEE - 2025 (Phase-3) Result
          </h2>

          <form>
            <input
              type="text"
              name="email"
              onChange={(e) => setApplicationNo(e.target.value)}
              placeholder="Application No / Email-Id / Mobile No"
              className="form-input my-3 w-full rounded-md shadow-sm border border-gray-300"
              style={{ textTransform: 'none' }}
              required
            />

            {/* Password with eye toggle */}
            <div className="relative mb-3">
              <input
                id="password"
                name="password"
                onChange={(e) => setDob(e.target.value)}
                type={passwordVisible ? 'text' : 'password'}
                placeholder="Password"
                className="form-input w-full rounded-md shadow-sm border border-gray-300 pr-10"
                required
              />
              <button
                type="button"
                onClick={() => setPasswordVisible(!passwordVisible)}
                className="absolute inset-y-0 right-0 px-3 text-gray-600 flex items-center focus:outline-none"
              >
                <i className={`fas ${passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`} />
              </button>
            </div>

            {/* CAPTCHA Display + Input */}
            <div className="mb-4 flex flex-row-reverse gap-2 items-center">
              <div className="flex items-center gap-2">
                <div
                  className="text-lg font-bold tracking-widest px-4 py-1 bg-gradient-to-br from-gray-200 to-white border border-gray-400 rounded font-mono select-none"
                  style={{
                    letterSpacing: '4px',
                    backgroundImage: 'linear-gradient(135deg, #f8fafc, #e2e8f0)',
                    textShadow: '1px 1px #aaa'
                  }}
                >
                  {captcha}
                </div>
                <button
                  type="button"
                  onClick={generateCaptcha}
                  className="text-xs text-blue-500 hover:underline"
                >
                  Refresh
                </button>
              </div>
              <input
                type="text"
                name="captchaInput"
                maxLength="6"
                value={captchaInput}
                onChange={(e) => setCaptchaInput(e.target.value)}
                placeholder="Enter Captcha"
                className="form-input mt-2 w-full rounded-md shadow-sm border border-gray-300"
                required
              />
            </div>

            <button
              onClick={onSubmit}
              className="w-full flex justify-center mt-2 py-2 px-4 rounded-md text-white font-semibold uppercase bg-[#e35d26] hover:bg-[#a94c26]"
            >
              Submit
            </button>
          </form>
        </div>
      </div>

     <div className="text-center mt-8 mb-6 px-4">
  <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
    <strong className="text-[#e35d26]">Note:</strong> Students with multiple applications should use only their 
    <span className="font-medium"> Application No. </span>
    to check the result.
  </p>
  <p className="text-sm sm:text-base text-gray-700 mt-2 leading-relaxed">
    If you are unable to check your result, please WhatsApp your 
    <span className="font-medium"> Name, Registered Mobile No,</span> and 
    <span className="font-medium"> Registered Email ID </span> on 
    <a
      href="https://wa.me/917488661870"
      target="_blank"
      rel="noopener noreferrer"
      className="text-[#e35d26] font-semibold hover:underline ml-1"
    >
      7488661870
    </a>.
  </p>
</div>


      <MDBModal show={optSmModal} tabIndex="-1" setShow={setOptSmModal}>
        <MDBModalDialog size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBBtn className="btn-close" color="none" onClick={toggleShow1}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>{data && <Card data={data} />}</MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </Rank>
  );
}

export default RankCard;
